
import Auth from '../../Auth/Auth';
export {
    authHeader, 
}
function authHeader(){
  return  {'Accept':'application/json',authorization:`Bearer ${Auth.getAccessToken()}`}
}